<div class="marquee-track" [ngClass]="{right:right}">
  <div class="marquee-group">
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
  </div>

  <div class="marquee-group" aria-hidden="true">
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
    <span>{{texts[0]}}</span>
    <span>{{texts[1]}}</span>
    <span>{{texts[2]}}</span>
    <span>{{texts[3]}}</span>
  </div>
</div>
